export const Role = {
  SuperAdmin: "Super Admin",
  HoManager: "HO Manager",
  CinemaManager: "Cinema Manager",
  PosOperator: "POS Operator", // PosOperator: 'POS Operator',
  PosFnBOperator: "FnB POS Operator",
  Distributor: "Distributor",
  BoxOfficeFnbOperator: "Box Office Fnb",
  AnalyticsManager: "Analytics Manager",
  KitchenManager: "Kitchen Manager",
  ProgrammingManager: "Programming Manager",
};

export const CLIENT_NAME = {
  CINEMA_AKIL: "Cinema Akil",
  EMPIRE: "empire",
  STUESSIHOF: "stuessihof",
  XANADU: "xanadu",
  PETRO: "petro",
  IRAQ: "Iraq",
  LEBANON: "lebanon",
  BILDHAUS: "bildhaus",
  QFX: "qfx",
  STAR: "starcinemas"
};

export const CLIENT_NAMES_OBJ = {
  empire_combo: ["empire", "petro", "Iraq", "starcinemas", "lebanon"],
  empire_iraq: ["empire", "Iraq"],
  multiple_ticket_clients: ["bildhaus", "carnival"],
  empire_iraq_lebanon: ["empire", "Iraq", "lebanon"],
  empire_clients: ["empire", "Iraq", "lebanon", "petro"],
  iraq: ["Iraq"],
  empire: ["empire"],
  xanadu: ["xanadu"],
  petro: ["petro"],
  stuessihof: ["stuessihof"],
  lebanon: ["lebanon"],
  bildhaus: ["bildhaus"],
  qfx: ["qfx"],
  star: ["starcinemas"],
  carnival: ["carnival"],
  bildhaus_qfx: ["bildhaus", "qfx"],
};



// WEBPACK FOOTER //
// ./src/helper/Role.js